export abstract class Formatting {

    public static formatPhone = (number: string): string => {
        return (number && number.length == 10) ?
            `(${number.substring(0, 3)}) ${number.substring(3, 6)}-${number.substring(6, 10)}`
            : number
    }
}